import * as React from "react";

export const WarningIcon: React.SFC = ({}) => (
  <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path
        d="M9.789 1.578l5.764 11.528A2 2 0 0 1 13.763 16H2.237a2 2 0 0 1-1.789-2.894L6.211 1.578a2 2 0 0 1 3.578 0z"
        fill="#F46036"
      />
      <path
        d="M8.741 10.38H7.335l-.2-5.911H8.94l-.199 5.912zm-.703.927c.285 0 .515.084.689.252.173.168.26.382.26.644a.85.85 0 0 1-.26.639c-.174.168-.404.252-.689.252-.281 0-.509-.084-.683-.252a.85.85 0 0 1-.26-.639.86.86 0 0 1 .26-.641c.174-.17.402-.255.683-.255z"
        fill="#FFF"
      />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/documentList/WarningIcon.tsx